const performScroll = (targetId, smooth) => {
  if (!targetId) return;

  const cleanId = targetId.startsWith('/')
    ? targetId.substring(1)
    : targetId;

  const section = document.getElementById(cleanId);

  if (!section) return;

  const header = document.getElementById('header');
  const headerHeight = header ? header.offsetHeight : 70;

  if (cleanId === 'início') {
    if (!smooth) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
      return;
    }

    animateScrollTo(0);
    return;
  }

  const sectionPosition =
    section.getBoundingClientRect().top + window.scrollY;

  const targetPosition = Math.max(
    0,
    sectionPosition - headerHeight
  );

  if (!smooth) {
    window.scrollTo({
      top: targetPosition,
      left: 0,
      behavior: 'auto'
    });
    return;
  }

  animateScrollTo(targetPosition);
};

const animateScrollTo = (targetPosition) => {
  const startPosition = window.scrollY;
  const distance = targetPosition - startPosition;

  if (Math.abs(distance) < 2) {
    window.scrollTo({
      top: targetPosition,
      left: 0,
      behavior: 'auto'
    });
    return;
  }

  const duration = Math.min(
    700,
    Math.max(250, Math.abs(distance) * 0.5)
  );

  const startTime = performance.now();

  const easeInOutQuad = (t) => {
    return t < 0.5
      ? 2 * t * t
      : -1 + (4 - 2 * t) * t;
  };

  const scrollAnimation = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutQuad(progress);

    window.scrollTo({
      top: startPosition + distance * easedProgress,
      left: 0,
      behavior: 'auto'
    });

    if (progress < 1) {
      requestAnimationFrame(scrollAnimation);
    } else {
      window.scrollTo({
        top: targetPosition,
        left: 0,
        behavior: 'auto'
      });
    }
  };

  requestAnimationFrame(scrollAnimation);
};

export const scrollToSection = (targetId, smooth = true, immediate = false) => {
  if (immediate) {
    performScroll(targetId, smooth);
    return;
  }

  setTimeout(() => {
    performScroll(targetId, smooth);
  }, 100);
};

export const scrollToTop = (smooth = true) => {
  if (!smooth) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    return;
  }

  animateScrollTo(0);
};